import React from 'react'
import { Switch } from 'react-router-dom'
import Home from '../containers/Home'

export default () => (
  <Switch>
    <Home />
  </Switch>
)